'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { SxProps, Theme } from '@mui/material';
import { BlockContainer } from '@/components/Blocks/BlockContainer';
import { CmsHtmlContent } from '@/components/CmsHtmlContent';
import type { CmsElementContent } from '@/services/cms/blocks/CmsElementContent';
export interface ElementContentBlockProps extends CmsElementContent {
  sx?: SxProps<Theme>;
}
export function ElementContentBlock(t0) {
  const $ = _c(9);
  let props;
  let sx;
  if ($[0] !== t0) {
    ({
      sx,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = sx;
  } else {
    props = $[1];
    sx = $[2];
  }
  let t1;
  if ($[3] !== props.html) {
    t1 = <CmsHtmlContent html={props.html} />;
    $[3] = props.html;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== sx || $[7] !== t1) {
    t2 = <BlockContainer sx={sx} {...props}>{t1}</BlockContainer>;
    $[5] = props;
    $[6] = sx;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}